import Intro from "@components/Post/Intro";
import Details from "@components/Post/Details";
const View = () => {
  return (
    <section data-scroll-section className="inner-content-full article-content">
      <Intro />
      <Details />
    </section>
  );
};
export default View;
